<template>
    <div>
        <app-title text="PQR's resueltas" />
        <b-row>
        <b-col cols="12" lg="4">
        <app-form-select-input
            placeholder="Tipo"
            :options="types"
            v-model="filters.type">
        </app-form-select-input>
        </b-col>
        <b-col cols="12" lg="1">
            <b-button variant="primary" class="btn-block" @click="filter"><i class="fa fa-filter"></i></b-button>
        </b-col>
        <b-col cols="12" md="4" lg="1">
            <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
        </b-col>
        </b-row>
        <br>
        <app-table-resolved-petitions
            :data="data"
            :on-change-page="onChangePage"
            :see-comments-by-petition="seeCommentsByPetition"
            :see-more="seeMore"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Comentarios de la petición" size="large" id="view-comments-petition-my-tasks">
            <div class="body" slot="body">
                <app-petition-comments-list :withActions="false" :comments="commentsPetitionSelect" />        
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more-my-tasks" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{petitionView.date | datetime}}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{petitionView.type}}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{petitionView.client}}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{petitionView.user}}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{petitionView.status}}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuarios asignados</h5>
                        <div v-if="petitionView.assignments"> 
                            <div v-for="assignment in petitionView.assignments">{{assignment.inactive?assignment.user.name:assignment.user.name +' (Actualmente)' }}</div>
                        </div>
                        <div v-if="!petitionView.assignments.length">No tiene</div>
                    </div>
                </div>
                <br>
                <h5 style="text-align:center">
                    <label for="anotation">Descripción</label>
                </h5>
                <textarea type="text" id="anotation" class="form-control" disabled="true" cols="80" rows="8" v-model="petitionView.description"></textarea>
            </div>
        </app-pop-up>      

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from '../../../repositories/petitions.repository.js';
import SubTitle from '../../UI/Layout/SubTitle.vue';
import TableResolvedPetitions from './TableResolvedPetitions/TableResolvedPetitions.vue';
import PetitionCommentsList from '../../ClientService/PetitionComment/PetitionCommentsList';
export default {
    components: {
        appSubTitle: SubTitle,
        appTableResolvedPetitions: TableResolvedPetitions,
        appPetitionCommentsList: PetitionCommentsList
    },

    data(){
        return{
            page: 1,
            data: {},
            commentsPetitionSelect: [],
            petitionView: {
                user: '',
                client: '',
                type: '',
                date: '',
                description: '',
                status: '',
                assignments: []
            },
            filters: {
                type: ''
            },
            sort: {
                sortBy: 'created_at',
                sortDir: 'asc'
            },
            types: []         
        }
    },

    methods: {
        filter() {
            this.loadPetitionsByUser();
        },
        clearFilters() {
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.loadPetitionsByUser();
        },
        loadPetitionsByUser(){
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            const pr = {...petitionsRepository};
            pr.loadResolvedPetitionsByUser(this.user.id, filters, this.page)
            .then(data =>{
                this.data = data;
            })
            .catch(error=>{
                toastr.error('Error al cargar las peticiones');
            });
        },
        seeCommentsByPetition(petition){
            this.commentsPetitionSelect = petition.comments;
            this.$bus.$emit('view-comments-petition-my-tasks.open');     
        },
        onChangePage(page){
            this.page = page;
            this.loadPetitionsByUser();
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(key => this.petitionView[key] = '');
            this.petitionView.user = petition.user.name;
            this.petitionView.client = petition.client.name;
            this.petitionView.type = petition.petition_type.name;
            this.petitionView.date = petition.created_at;
            this.petitionView.description = petition.description;
            this.petitionView.status = petition.petition_status.name;
            this.petitionView.assignments = petition.petition_assignment;

            this.$bus.$emit('view-petition-more-my-tasks.open');
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadPetitionsByUser();
        },
        async loadPetitionTypes() {
            const {data} = await repo.get('petitions/types', null, 'Lo sentimos, ha ocurrido un error');
            this.types = data;
        }
    },

    created() {
        this.loadPetitionsByUser();
        this.loadPetitionTypes();
    }
}
</script>

